import { Component, Input, OnInit } from '@angular/core';
import { StatusSPM } from '@pages/spm/submenu.enum';
import { BehaviorSubject } from 'rxjs';
import { ICardHeaderInformation } from '@shared/components/card/card-header/card-header.model';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { UtilitiesService } from '@services/utilities.service';
import { StatusSalesOrder } from '@config/enum/status.enum';

@Component({
  selector: 'app-card-header-information',
  templateUrl: './card-header-information.component.html',
  styleUrls: ['./card-header-information.component.scss'],
})
export class CardHeaderInformationComponent implements OnInit {
  @Input() detail: BehaviorSubject<ICardHeaderInformation | null>;
  @Input() isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  ASSETS_ICON = STRING_CONSTANTS.ICON;
  constructor(public utilities: UtilitiesService) {}

  ngOnInit(): void {}

  renderStatusBadge() {
    const { status_enum, status_string } = this.detail.value as ICardHeaderInformation;
    return `<span class="badge badge__status  badge__status--${status_enum}"> ${status_string} </span>`;
  }

  copyToClipboard = (data: string | undefined) => navigator.clipboard.writeText(data ?? '');

  generateDate(value: number) {
    if (!value) return '-';
    // return this.utilities.timeStampToDate(value.toString(), 'dd-MM-yyyy, HH:mm:ss');
    return this.utilities.formatEpochToDate(value, 'dd-MM-yyyy, HH:mm:ss');
  }

  generateTitleIdErp(code: string) {
    if (code.substring(0, 3) === 'SPM') {
      return 'ID SPM ERP:';
    }
    return 'ID ERP:';
  }

  getCopyClipboardText(isTagCode = false) {
    const detail = this.detail.value as ICardHeaderInformation;
    const { tag_code, code, erp_code } = detail;
    return isTagCode ? { label: 'Tag Code', value: tag_code ?? '' } : { label: this.generateTitleIdErp(code), value: erp_code ?? '' };
  }

  getCopyClipboardValue(isTagCode = false) {
    if (!this.detail.value) return '';
    if (isTagCode) return this.detail.value.tag_code as string;
    return this.detail.value.erp_code as string;
  }

  showCopyClipboard() {
    const _allowedStatus = [StatusSPM.PARTIAL_COMPLETED, StatusSPM.FINISH, StatusSalesOrder.COMPLETED, StatusSalesOrder.OUTSTANDING].toString();

    const _currentStatusEnum = this.detail.value && this.detail.value.status_enum;
    return this.hasErpCode() && _allowedStatus.includes(_currentStatusEnum as string);
  }

  hasTagCode = () => !!(this.detail.value && this.detail.value.tag_code);

  hasErpCode = () => !!this.detail.value?.erp_code;
}
